import React from "react";
import { ErrorMessage, useField } from "formik";
import FieldError from "./FieldError";
const TextArea = ({ label, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <>
      {props.sublabel && props.sublabel}
      {label && <label>{label}</label>}
      <textarea rows="2" id="textarea" name={props.name} {...field} {...props} />
      {meta.touched && meta.error && (
        <span id="error">
          <FieldError error={meta.error} />
        </span>
      )}
      {props.children && props.children}
    </>
  );
};

export default TextArea;
